module.exports = __webpack_public_path__ + "static/media/Long-arrow.5b38a708.svg";